import React from "react";
import AllInclusiveIcon from "@material-ui/icons/AllInclusive";
import {fetchCustomers} from "../../../actions";
import {filterObject} from "../../../util/bbHelpers";
import DataTile from "./DataTile";


const Tile = (props) => {
    return (
        <DataTile
            color="secondary"
            subTitle="Active Strombolis"
            icon={<AllInclusiveIcon style={{fontSize: "70px"}}/>}
            stateName="customer"
            stateElement="customers"
            stateLoaderName="loadingCustomers"
            stateLoaderError="loadingCustomersError"
            stateFetchAction={fetchCustomers()}
            valueFunction={(stateData) => stateData ? Object.keys(filterObject(stateData, (_, customer) => customer.Stromboli ? customer.Stromboli["Service Active"] === "1" : false)).length : null}
        />
    )

};

export default Tile;

